import Image from 'components/Image'
import AppIcon from 'static/images/app-icon200x200.png'
import AppStoreIcon from 'static/images/apple-appstore.svg'
import GooglePlayStoreIcon from 'static/images/google-playstore.svg'
type Props = {
  androidLink: string
  iosLink: string
  title: string
}

const TrucksAppLinks = ({ androidLink, iosLink, title }: Props) => (
  <div className="bg-white rounded-xl max-w-max mx-auto shadow-lg px-4 relative">
    <div className="mx-auto max-w-max absolute -top-1/2 left-1/2 transform -translate-x-1/2 translate-y-1/2">
      <Image
        alt="bestfoodtrucks logo"
        className="rounded-3xl"
        height={100}
        src={AppIcon}
        width={100}
      />
    </div>
    <div className="mt-12 py-8 px-4">
      <div className="text-center text-2xl font-semibold mt-12">{title}</div>
      <div className="flex mt-4">
        <div className="w-1/2 pr-2 cursor-pointer">
          {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
          <a href={iosLink}>
            <Image
              alt="ios app"
              className="rounded-lg shadow-md"
              height={50}
              src={AppStoreIcon}
              width={175}
            />
          </a>
        </div>
        <div className="w-1/2 pr-2 cursor-pointer">
          {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
          <a href={androidLink}>
            <Image
              alt="android app"
              className="rounded-lg shadow-md"
              height={50}
              src={GooglePlayStoreIcon}
              width={175}
            />
          </a>
        </div>
      </div>
    </div>
  </div>
)

export default TrucksAppLinks
